import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLanguageService } from "../../services/language.service";
import { FormControl } from "@angular/forms";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { UserHelperService } from "../../services/userHelper.service";
import { UserProfileService } from "../userProfile/userprofile.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { WarningdialogComponent } from "../../modalDialogs";
import { GroupOrderInviteService } from "./groupOrderInvite.service";
import { GroupMember, JoinGroupResult } from "./groupOrderInvite.facade";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import Utils from "../../shared/utils";
import { LocationService } from "../location/location.service";
import { WebShopMode } from "../../shared/contentTypes";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { forbiddenNameValidator, ValidatorsConfig } from "../../shared/validator/validator.function";
import { WebShopService } from "../../services/webShop.service";

@Component({
  selector: "groupOrderInvite",
  templateUrl: "./groupOrderInvite.component.html",
  styleUrls: ["./groupOrderInvite.component.scss"],
  providers: [OverlaySpinnerService, GroupOrderInviteService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class GroupOrderInviteComponent implements OnInit, OnDestroy {

  private _langSubscriber: Subscription;
  private _userNameInputSubscriber: Subscription;
  private _validationSubscriber: Subscription;

  // parameter
  private group_code: string = ""; // requiert
  private location: number = 0; // optional
  private group_name: string = ""; // optional
  private group_creator: string = ""; // optional

  private nickname: string;
  private table_no: string;
  public isSmallView: boolean = false;

  public userNameInputFormControl = new FormControl('', {
    validators: ValidatorsConfig.forGroupMemberName(),
    asyncValidators: forbiddenNameValidator(this._webShopService),
  });

  constructor(private _userHelperService: UserHelperService
    , private _location: Location
    , private _webShopService: WebShopService
    , private _groupOrderInviteService: GroupOrderInviteService
    , private _inHouseOrderService: InHouseOrderService
    , private _userProfileService: UserProfileService
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private internationalisationService: InternationalisationService
    , private _iosHelperService: IOSHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _activatedRoute: ActivatedRoute
    , private _locationService: LocationService
    , private _overlaySpinnerService: OverlaySpinnerService
  ) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("GroupOrderInviteComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;

    me.group_code = null;
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData) {
      me.group_code = routeTargetData["groupcode"];
      // optionale parameter
      if (routeTargetData["location"]) {
        me.location = +(routeTargetData["location"]);
        me.group_name = routeTargetData["groupname"];
        me.group_creator = routeTargetData["groupcreator"];
      }
    }

    if (!me.group_code) {
      me._coreLogService.error("GroupOrderInviteComponent.ngOnInit", "no group_code");
      me._router.navigate(["/"]); // back to home
      return; // exit here
    }

    me._groupOrderInviteService.isAlwasyMemberOfGroup(me.group_code).then(async (isAlwasyMember) => {
      if (isAlwasyMember != GroupMember.Not) {
        //message and redirekt to group overview
        me.OpenWarningAlreadyMember();
      } else {
        try {
          const info = await me._groupOrderInviteService.getGroupCodeInfo(me.group_code);
          if (info.valide) {
            if (!info.isFull) {
              // prüfung ob die übergebenen parameter stimmen
              if (me.location > 0) {
                let equal = me.location == info.location;
                equal = equal && me.group_name == info.groupInfo.groupName;
                equal = equal && me.group_creator == info.groupInfo.groupCreator;
                if (!equal) {
                  me._coreLogService.error("GroupOrderInviteComponent.ngOnInit", "Params and GroupCodeInfo not equal", me.location, info.location, me.group_name, info.groupInfo.groupName, me.group_creator, info.groupInfo.groupCreator);
                }
              }
              me.location = info.location;
              me.table_no = info.tableNo;
              me.group_name = info.groupInfo.groupName;
              me.group_creator = info.groupInfo.groupCreator;

              // check open time of location
              const locationInfo = await me._locationService.GetWebshopLocationInfoViewModel(WebShopMode.OrderToTable, me.location);
              if (locationInfo && locationInfo.checkOpenTime()) {
                me.PushChanges();
                // try set to old group
                me._overlaySpinnerService.ShowLayoutSpinner();
                try {
                  const got_old_place = await me._inHouseOrderService.TryUseCachedDataForGroup(me.group_code);
                  if (got_old_place) {
                    await me._inHouseOrderService.openInHauseLandingPage();
                  } // else get new place
                } catch (error) {
                  me._coreLogService.error("GroupOrderInviteComponent.ngOnInit", "TryUseCachedDataForGroup.catch");
                }
                me._overlaySpinnerService.HideLayoutSpinner();
              } else {
                me.OpenWarningLocationClosed(); // mit auto redirect
              }
            } else {
              me.OpenWarningMaxCountReached(); // mit auto redirect
            }
          } else {
            me.OpenWarningLinkExpired(); // mit auto redirect
          }
        } catch (error) {
          me._coreLogService.error("GroupOrderInviteComponent.ngOnInit", "_groupOrderInviteService.getGroupCodeInfo (catch)", error);
          me.OpenWarningLinkExpired(); // mit auto redirect
        }
      }
    }).catch((error) => {
      me._coreLogService.error("GroupOrderInviteComponent.ngOnInit", "_groupOrderInviteService.isAlwasyMemberOfGroup (catch)", error);
      me.OpenWarningLinkExpired(); // mit auto redirect
    });

    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    //!Mark button active if value is valid, so in case to change button state need statusChange subscriber
    /** get latest validation status of that control whenever validation status is recalculated for that control. */
    me._validationSubscriber = me.userNameInputFormControl.statusChanges.subscribe(() => {
      me.PushChanges();
    });

    /** get latest value of that control whenever there is any change. */
    me._userNameInputSubscriber = me.userNameInputFormControl.valueChanges.subscribe(async () => {
      me.userNameInputFormControl.markAsTouched();
      me.nickname = me.userNameInputFormControl.value;
      me.PushChanges();
    });
    me.InitUserProfileName();
    me.PushChanges();
  }

  /** Initialisiert den Nickname mit dem Vornamen, wenn der User eingeloggt ist */
  private async InitUserProfileName(): Promise<void> {
    const me = this;
    if (me._userHelperService.IsRegistered) {
      try {
        const userViewModel = await me._userProfileService.GetUserInfoViewModel();
        me.nickname = userViewModel.fname;
        me.userNameInputFormControl.setValue(me.nickname);
        me.PushChanges();
      } catch (error) {
        me._coreLogService.error("GroupOrderInviteComponent.GetUserProfileName", "GetUserInfoViewModel", error);
      }
    }
  }

  public get welcomeLabel(): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_Invitation_Recieved_Title")
      .replace("{groupName}", `<br><span class="emphasized">${me.group_name}</span><br>`)
      .replace("{userName}", `<span class="emphasized">${me.group_creator}</span>`)
  }

  public get inputPlaceholder(): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_Invitation_Recieved_input")
  }

  public setBtnStateByUserName(): boolean {
    const me = this;
    return !Utils.IsNullOrEmpty(me.userNameInputFormControl.value) && me.userNameInputFormControl.valid ? true : false;
  }

  public setWebView(): void {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public async joinGroupOrder(): Promise<void> {
    const me = this;

    me._overlaySpinnerService.ShowLayoutSpinner();
    const joinResult = await me._groupOrderInviteService.joinGroup(me.nickname, me.location, me.table_no, me.group_name, me.group_code);

    switch (joinResult) {
      case JoinGroupResult.Okay:
        // es hat funktioniert, es findet eine automatische weiterleitung statt
        me._overlaySpinnerService.HideLayoutSpinner();
        break;
      case JoinGroupResult.WrongUserName:
        me._overlaySpinnerService.HideLayoutSpinner();
        me.OpenWarningCreateUserNameFailed();
        break;
      case JoinGroupResult.GroupFull:
        me._overlaySpinnerService.HideLayoutSpinner();
        me.OpenWarningMaxCountReached();
        break;
      case JoinGroupResult.UserIsInGroup:
        me._overlaySpinnerService.HideLayoutSpinner();
        // aufruf hätte nicht stattfinden dürfen
        // todo redirect to group overview
        break;
      case JoinGroupResult.Fail:
        me._overlaySpinnerService.HideLayoutSpinner();
        // etwas ist fehlgeschlagen
        me.OpenWarningLinkExpired();
        break;
      default:
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreLogService.error("GroupOrderInviteComponent.joinGroupOrder", "_groupOrderInviteService.joinGroup unknown joinResult", joinResult);
        break;
    }
  }

  public denyGroupOrder(): void {
    const me = this;
    me._router.navigate(["/"]); // back to home
  }

  /** Warning dialog: Der Standort ist momentan geschlossen  */
  private OpenWarningLocationClosed() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_LocationClosed_Title"
        , content: "phGroupOrder_LocationClosed_SubText"
        , btnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      me._router.navigate(["/menuservice"]);
    });
  }

  /** Warning dialog: Max Count reached  */
  private OpenWarningMaxCountReached() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_MaxMemberCount_Title"
        , content: "phGroupOrder_MaxMemberCount_SubText"
        , btnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      me._router.navigate(["/menuservice"]);
    });
  }

  /** Warning dialog:Group expired  */
  private OpenWarningLinkExpired() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_LinkExpired_Title"
        , content: "phGroupOrder_LinkExpired_SubText"
        , btnLabel: "phGroupOrder_LinkExpired_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      me._router.navigate(["/menuservice"]);
    });
  }

  /** Warning dialog: user is already group member*/
  private OpenWarningAlreadyMember() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_UserIsAlready_Member_Title"
        , content: "phGroupOrder_UserIsAlready_Member_SubText"
        , btnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      me._inHouseOrderService.openInHauseLandingPage()
    });
  }

  /** Warning dialog: user name  */
  private OpenWarningCreateUserNameFailed() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_CreateGroup_UserName_Failed_Title"
        , content: "phGroupOrder_CreateGroup_Name_Failed_SubText"
        , btnLabel: "phGlobal_Return"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }
  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._userNameInputSubscriber) {
      me._userNameInputSubscriber.unsubscribe();
    }
    if (me._validationSubscriber) {
      me._validationSubscriber.unsubscribe();
    }
  }
}
